module.exports = __webpack_public_path__ + "static/media/IMG_0026-2.f1950614.jpg";